var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCopilotLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M183.402 39.7757C180.172 30.3395 171.3 24 161.327 24L150.192 24C138.898 24 129.225 32.0885 127.227 43.2041L115.607 107.825L120.13 92.6634C123.08 82.7763 132.172 76 142.49 76L184.474 76L202.443 86.4721L219.764 76H212.478C202.504 76 193.633 69.6605 190.403 60.2243L183.402 39.7757Z",
    fill: "url(#paint0_radial_44229_107)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1715 216.118C78.3695 225.609 87.2679 232.001 97.2833 232.001H116.582C129.418 232.001 139.844 221.633 139.915 208.797L140.252 147.891L135.76 163.227C132.847 173.17 123.728 180.001 113.367 180.001H71.1172L55.7155 168.172L39.041 180.001H46.2416C56.257 180.001 65.1553 186.393 68.3534 195.884L75.1715 216.118Z",
    fill: "url(#paint1_radial_44229_107)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M158.002 24H70.5022C45.5024 24 30.5024 56.7133 20.5025 89.4266C8.65513 128.183 -6.84737 180.017 38.0024 180.017H77.285C87.693 180.017 96.8407 173.132 99.7269 163.132C106.228 140.607 118.001 99.9946 127.212 69.2154C131.808 53.8599 135.635 40.6723 141.51 32.4599C144.803 27.8557 150.292 24 158.002 24Z",
    fill: "url(#paint2_linear_44229_107)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M158.002 24H70.5022C45.5024 24 30.5024 56.7133 20.5025 89.4266C8.65513 128.183 -6.84737 180.017 38.0024 180.017H77.285C87.693 180.017 96.8407 173.132 99.7269 163.132C106.228 140.607 118.001 99.9946 127.212 69.2154C131.808 53.8599 135.635 40.6723 141.51 32.4599C144.803 27.8557 150.292 24 158.002 24Z",
    fill: "url(#paint3_linear_44229_107)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9824 232.001H185.482C210.482 232.001 225.482 199.284 235.482 166.566C247.329 127.805 262.832 75.9648 217.982 75.9648H178.7C168.292 75.9648 159.144 82.8505 156.258 92.8506C149.756 115.378 137.983 155.997 128.772 186.78C124.177 202.137 120.349 215.327 114.475 223.54C111.181 228.145 105.692 232.001 97.9824 232.001Z",
    fill: "url(#paint4_radial_44229_107)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9824 232.001H185.482C210.482 232.001 225.482 199.284 235.482 166.566C247.329 127.805 262.832 75.9648 217.982 75.9648H178.7C168.292 75.9648 159.144 82.8505 156.258 92.8506C149.756 115.378 137.983 155.997 128.772 186.78C124.177 202.137 120.349 215.327 114.475 223.54C111.181 228.145 105.692 232.001 97.9824 232.001Z",
    fill: "url(#paint5_linear_44229_107)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_44229_107",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(204.598 108.373) rotate(-130.79) scale(90.3521 85.7334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0955758,
    stopColor: "#00AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773185,
    stopColor: "#2253CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0736C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_44229_107",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.4029 175.586) rotate(50.1613) scale(82.6085 81.1371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB657"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633728,
    stopColor: "#FF5F3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923392,
    stopColor: "#C02B3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_44229_107",
    x1: 65.2652,
    y1: 42.9045,
    x2: 77.5051,
    y2: 185.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.156162,
    stopColor: "#0D91E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487484,
    stopColor: "#52B471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652394,
    stopColor: "#98BD42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.937361,
    stopColor: "#FFC800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_44229_107",
    x1: 76.1759,
    y1: 24,
    x2: 82.8589,
    y2: 180.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DCBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246674,
    stopColor: "#0588F7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_44229_107",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(222.477 60.6878) rotate(109.453) scale(207.558 250.596)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0661714,
    stopColor: "#8C48FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F2598A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895833,
    stopColor: "#FFB152"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_44229_107",
    x1: 229.389,
    y1: 66.4385,
    x2: 229.302,
    y2: 108.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0581535,
    stopColor: "#F8ADFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708063,
    stopColor: "#A86EDD",
    stopOpacity: 0
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCopilotLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/CopilotLogo.c946d6f0ed734f5847d2c88416db628a.svg";